import { Identifiable, list, ProjectStatus, Zone } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { LinkedProject } from "./types";

function linkProject(httpClient: HttpClient) {
  return (project: LinkedProject): Promise<LinkedProject> => {
    return Promise.all([
      httpClient
        .sendHttpRequest<Identifiable<ProjectStatus>>({
          endpoint: `/projects/${project.uuid}/status`,
          method: HttpMethods.GET,
        })
        .then((status) => ({
          ...project,
          status,
        })),
      httpClient
        .sendHttpRequest<Identifiable<Zone>>({
          endpoint: `/projects/${project.uuid}/zone`,
          method: HttpMethods.GET,
        })
        .then((zone) => ({
          ...project,
          zone,
        })),
    ])
      .then((projectParts) =>
        projectParts.reduce((p, part) => ({ ...p, ...part }), project),
      )
      .then((project) => ({
        ...project,
        rootList: { ...list, ...project.activityRoot },
        isTemplate: project.isTemplate || project.template,
        tags: project.tags
          ? (project.tags as any).map((name: string) => ({ name }))
          : [],
      }));
  };
}

export { linkProject };
